import { sf_mucthuphi_select_request } from "../models/request/mucthuphi/sf_mucthiphi_select_rq";
import { apiClient } from "./apiClient";

export interface CongNoSelectByHocSinhRequest {
  ts_hocsinh_id: number;
  nam_hoc: string;
}

export const baoCaoHocPhiApi = {
  reportAlpha: (request: sf_mucthuphi_select_request) => {
    return apiClient.post(`baocao_hocphi/report-congno-alpha`, request);
  },
  reportCongNoAll: (request: sf_mucthuphi_select_request) => {
    return apiClient.post(`baocao_hocphi/report-congno-all`, request);
  },
  SelectDashBoard: (request: any) =>
    apiClient.post(`baocao_hocphi/dashboard-cong-no`, request),
  selectByHocSinh: (request: CongNoSelectByHocSinhRequest) =>
    apiClient.post(`baocao_hocphi/select_by_hocsinh`, request),
};
